/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';
import { customArray } from './service';
import CountryInput from './country-input';
import './country-input/styles/bootstrap.css';
import rawCountries from './country-input/rawCountries';
import { toLowerCase } from 'js-convert-case';

export interface ICountrySelectInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
    readOnly?: boolean;
    onlyCountries?: string[];
    preferredCountries?: string[];
    excludeCountries?: string[];
}

export const CountrySelectInput = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    onlyCountries,
    preferredCountries,
    excludeCountries,
    hasError,
    readOnly,
}: ICountrySelectInputProps) => {
    const getCountryCode = () => {
        if (value) {
            return rawCountries.filter(
                (item) => toLowerCase(item?.[0]) === toLowerCase(value)
            )?.[0]?.[2];
        }
        return '';
    };
    const [textValue, setTextValue] = useState(getCountryCode());
    useEffect(() => setTextValue(getCountryCode()), [value]);

    const onChange = (id: string, e: any, country, formattedNumber) => {
        console.log('hg->', country);
        setTextValue(country?.countryCode);
        onCompChange && onCompChange(id, country?.name);
    };

    // const options = customArray(
    //     {
    //       name: "{countryCode}",
    //       value: "{countryNameEn} {flag}",
    //     },
    //     { filter: validateCountry }
    //   );

    // const validateCountry = (country: any) => {
    //   if (whitelistedCountries?.length) {
    //     const countries = whitelistedCountries?.map((country) =>
    //       country.toLowerCase()
    //     );
    //     return countries.includes(country?.countryCode?.toLowerCase());
    //   }
    //   return true;
    // };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <CountryInput
                        className="formcontrol shadow-none"
                        onChange={onChange.bind(null, id)}
                        required={required}
                        country={textValue}
                        fontScale={fontScale}
                        value={textValue}
                        disableDropdown={readOnly}
                        placeholder={placeholder}
                        enableSearch={true}
                        buttonStyle={{ width: '100%' }}
                        onlyCountries={onlyCountries}
                        preferredCountries={preferredCountries}
                        excludeCountries={excludeCountries}
                        autocompleteSearch={true}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

CountrySelectInput.defaultProps = {
    required: false,
    hasError: false,
    whitelistedCountries: [],
};
